<template>
  <section>
    <Feature :title="$t('PCB_MASTER_MAINTAIN')" :iconClass="'fa-database'">
      <FormRow
        :fieldNameArr="[$t('PCB_VENDOR_CODE'), $t('CCL_LAMINATE_TYPE'), $t('LAYER'), $t('INTERNAL_COPPER_THICKNESS_TITLE'), $t('VALID_FROM'), $t('LOG')]">
        <Select style="width: 200px" v-model="pcbVnCode" :placeholder="$t('CHOOSE')" slot="a">
          <Option v-for="(item) in pcbVnCodes" :value="item" :key="item">
            {{ item }}
          </Option>
        </Select>
        <Select style="width: 200px" v-model="cclLaminateType" :placeholder="$t('CHOOSE')" slot="b">
          <Option v-for="(item) in cclLaminateTypes" :value="item" :key="item">
            {{ item }}
          </Option>
        </Select>
        <Select style="width: 200px" v-model="layer" :placeholder="$t('CHOOSE')" slot="c">
          <Option v-for="(item) in layers" :value="item" :key="item">
            {{ item }}
          </Option>
        </Select>
        <Select style="width: 200px" v-model="internalCopperThickness" :placeholder="$t('CHOOSE')" slot="d">
          <Option v-for="(item) in internalCopperThicknesses" :value="item" :key="item">
            {{ item }}
          </Option>
        </Select>
        <DatePicker v-model="validFrom" type="date" format="yyyy-MM-dd" :placeholder="$t('VALID_FROM')" slot="e">
        </DatePicker>
        <i-switch v-model="isLog" slot="f"></i-switch>
      </FormRow>
      <ButtonRow>
        <Button type="primary" @click="search" slot="0">{{ $t('COMMON_TEXT_SEARCH') }}</Button>
        <Button type="primary" @click="upload" slot="1">{{ $t('UPLOAD') }}</Button>
        <Button type="primary" @click="clear" slot="2">{{ $t('CLEAR') }}</Button>
      </ButtonRow>
      <Feature v-show="existedPriceList" :title="'Data'" :iconClass="'fa-pencil-square-o'">
        <Button type="primary" @click="download">{{ $t('DOWNLOAD') }}</Button>
        <TablePage :tableWidth="windowWidth" :columnsList="columnsList" :resultList="priceList" :pageObj="pageObj"
          @changePage="changePage"></TablePage>
      </Feature>
    </Feature>
    <Modal :z-index="modalSize" :reset-drag-position="true" @on-ok="uploadOk" @on-cancel="uploadCancel" sticky
      :draggable="true" v-model="model" :title="$t('UPLOAD')">
      <FormRow :fieldNameArr="['STEP1']">
        <Button icon="md-cloud-download" type="success" slot="a" @click="downloadSample">{{ $t('DOWNLOAD') }}</Button>
      </FormRow>
      <I style="color: red">Please use excel file, and the first row is column description which will not upload to
        system. Please input your data from second row.</I>
      <FormRow :fieldNameArr="['File Upload (File Size < 5MB)', file == null ? '' : file.name]">
        <Upload slot="a" :before-upload="handleUpload" action="*">
          <Button icon="ios-cloud-upload">{{ $t('UPLOAD') }}</Button>
        </Upload>
        <Button type="primary" v-show="file !== null" slot="b" @click="uploadFile">{{ $t('CLICK_UPLOAD') }}</Button>
      </FormRow>
    </Modal>
  </section>
</template>

<script>
import { mapGetters } from "vuex"
import { mapActions } from "vuex"
import { AlertInfo } from "@/util/alert"
import { Translate, ExceptionHandling, DateToString } from "@/util/common"

export default {
  name: "PcbMasterMMaintain",
  created() {
    const vueInstance = this
    vueInstance.$getReferenceData(vueInstance, "/pcbMaster/find/cclLaminateType").then(data => {
      if (data) {
        vueInstance.cclLaminateTypes = data.sort(function (a, b) {
          return a.localeCompare(b, "en");
        });
      }
    }).catch((error) => {
      // AlertInfo(this, this.$t('COMMON_MESSAGE_SYSTEM_ERROR')).then(() => {
      // })
    })
    vueInstance.$getReferenceData(vueInstance, "/pcbMaster/find/pcbVnCode").then(data => {
      if (data) {
        vueInstance.pcbVnCodes = data.sort(function (a, b) {
          return a.localeCompare(b, "en");
        });
      }
    }).catch((error) => {
      // AlertInfo(this, this.$t('COMMON_MESSAGE_SYSTEM_ERROR')).then(() => {
      // })
    })
    vueInstance.$getReferenceData(vueInstance, "/pcbMaster/find/layer").then(data => {
      if (data) {
        vueInstance.layers = data.sort()
      }
    }).catch((error) => {
      // AlertInfo(this, this.$t('COMMON_MESSAGE_SYSTEM_ERROR')).then(() => {
      // })
    })
    vueInstance.$getReferenceData(vueInstance, "/pcbMaster/find/internalCopperThickness").then(data => {
      if (data) {
        vueInstance.internalCopperThicknesses = data.sort()
      }
    }).catch((error) => {
      // AlertInfo(this, this.$t('COMMON_MESSAGE_SYSTEM_ERROR')).then(() => {
      // })
    })
  },
  data() {
    return {
      model: false,
      validFrom: null,
      isLog: false,
      file: null,
      pcbVnCode: '',
      pcbVnCodes: [],
      cclLaminateType: '',
      cclLaminateTypes: [],
      layer: '',
      layers: [],
      internalCopperThickness: '',
      internalCopperThicknesses: [],
      priceList: [],
      pageObj: {
        "page": 0,
        "totalPage": 0,
        "totalCount": 0,
        "pageSize": 20
      },
      columnsList: [
        {
          renderHeader: (h, params) => {
            var text = this.$t('GROUP_NAME_FEILD')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          key: "pcbGroup",
          sortable: true
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('PCB_VENDOR_CODE_FEILD')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          key: "pcbVnCode",
          sortable: true
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('CCL_LAMINATE_TYPE')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          key: "cclLaminateType",
          sortable: true
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('LAYER')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          key: "layer",
          sortable: true
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('PCB_THICKNESS') + "(mm)"
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          key: "pcbThickness",
          sortable: true
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('EXTERNAL_COPPER_THICKNESS') + "(oz)"
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          key: "externalCopperThickness",
          sortable: true
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('INTERNAL_COPPER_THICKNESS') + "(oz)"
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          key: "internalCopperThickness",
          sortable: true
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('TG')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          key: "tgCode",
          sortable: true
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('PCB_PRICE_SHEET_BASE')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          key: "pcbPriceSheetBase",
          sortable: true
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('PCB_PRICE_ACTUAL_PANEL_BASE')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          key: "pcbPriceActualPanelBase",
          sortable: true
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('CURRENCY')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          key: "currency",
          sortable: true
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('PROCESS_LOSE') + "(mm)"
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          key: "processLose",
          sortable: true
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('EXTEND') + "(itch)"
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          key: "extend",
          sortable: true
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('VALID_FROM')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          key: "validFrom",
          sortable: true
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('VALID_TO')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          key: "validTo",
          sortable: true
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('REMARK')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          key: "remark",
          sortable: true
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('CREATE_GROUP_ACCOUNT')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          key: "createGroupAccount",
          sortable: true
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('CREATE_DATE')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          key: "created",
          sortable: true
        },
        {
          title: this.$t('ENABLED'),
          align: "center",
          render: (h, params) => {
            let value = params.row["enabled"] ? "YES" : "NO"
            return h("span", {}, value)
          }
        }
      ],
      dataList: []
    }
  },
  methods: {
    ...mapGetters(["getUserProfile", "getLanguage", "getModalSize", "getWindowsWidth"]),
    ...mapActions(["toggleLoading"]),
    search(init) {
      const vueInstance = this
      if (init) {
        vueInstance.pageObj = {
          "page": 0,
          "totalPage": 0,
          "totalCount": 0,
          "pageSize": 20
        }
      }
      vueInstance.toggleLoading(true)
      vueInstance.$quotationHttp
        .post('/pcbMaster/search?sort=pcbGroup&sort=pcbVnCode&sort=cclLaminateType&sort=layer&sort=pcbThickness&sort=externalCopperThickness&sort=internalCopperThickness&sort=pcbPriceSheetBase&sort=pcbPriceActualPanelBase&sort=currency&sort=validFrom&page='
          + vueInstance.pageObj.page + '&size=' + vueInstance.pageObj.pageSize, JSON.stringify(buildCriteria(vueInstance)))
        .then((response) => {
          vueInstance.toggleLoading(false)
          vueInstance.priceList = []
          if (response.data._embedded) {
            let data = response.data
            vueInstance.priceList = data._embedded.pcbMasterResourceList
            vueInstance.pageObj = {
              "page": data.page.number + 1,
              "totalPage": data.page.totalPages,
              "totalCount": data.page.totalElements,
              "pageSize": data.page.size
            }
          } else {
            vueInstance.$Notice.success({
              title: Translate("COMMON_MESSAGE_INFO"),
              desc: Translate("COMMON_MESSAGE_INFO"),
              render: h => {
                return h('span', [
                  Translate("COMMON_TEXT_NOTHING")
                ])
              }
            });
          }
        })
        .catch((error) => {
          console.log(error.response)
        })
    },
    changePage(page) {
      this.pageObj.page = page - 1
      this.search(false)
    },
    uploadOk() {
      this.file = null
    },
    uploadCancel() {
      this.file = null
    },
    upload() {
      this.model = true
    },
    downloadSample() {
      this.$downloadMasterAttachment(this, 'PCBMasterDataMaintain')
    },
    handleUpload(file) {
      this.file = file;
      return false;
    },
    uploadFile() {
      let fd = new FormData()
      fd.append('file', this.file)
      this.toggleLoading(true)
      this.$quotationHttp
        .post("/pcbMaster/uploadExcel", fd)
        .then((response) => {
          console.log(response)
          this.file = null
          this.model = false
          this.search(true)
          this.$Swal.fire({
            icon: "info",
            title: Translate("COMMON_MESSAGE_SUCCESS"),
            text: response.data.content[0].status,
          })
        })
        .catch((error) => {
          this.toggleLoading(false)
          let text = ExceptionHandling(error.response)
          this.$Swal.fire({
            icon: "error",
            title: Translate("COMMON_MESSAGE_ERROR"),
            html: text,
          })
        })
    },
    clear() {
      const vueInstance = this
      vueInstance.validFrom = null
      vueInstance.validTo = null
      vueInstance.pcbVnCode = ''
      vueInstance.cclLaminateType = ''
      vueInstance.layer = ''
      vueInstance.internalCopperThickness = ''
    },
    download() {
      this.$downloadExcel(this, "pcbMaster", buildCriteria(this), "?sort=pcbGroup&sort=pcbVnCode&sort=cclLaminateType&sort=currency&sort=validFrom")
    }
  },
  computed: {
    modalSize() {
      return this.getModalSize()
    },
    windowWidth() {
      return this.getWindowsWidth() - 50
    },
    existedPriceList() {
      return this.priceList && this.priceList.length > 0
    }
  }
}

function buildCriteria(vueInstance) {
  return {
    "pcbVnCode": vueInstance.pcbVnCode != "" ? vueInstance.pcbVnCode : null,
    "cclLaminateType": vueInstance.cclLaminateType != "" ? vueInstance.cclLaminateType : null,
    "layer": vueInstance.layer != "" ? vueInstance.layer : null,
    "internalCopperThickness": vueInstance.internalCopperThickness != "" ? vueInstance.internalCopperThickness : null,
    "validFrom": vueInstance.validFrom != "" && vueInstance.validFrom != null ? DateToString(vueInstance.validFrom, "-") : null,
    "enabled": !vueInstance.isLog
  }
}
</script>

<style scoped></style>
